/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Reject_SamplesInputs */

const en_samples_reject_samples = /** @type {(inputs: Samples_Reject_SamplesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reject Samples`)
};

const es_samples_reject_samples = /** @type {(inputs: Samples_Reject_SamplesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechazar muestras`)
};

/**
* | output |
* | --- |
* | "Reject Samples" |
*
* @param {Samples_Reject_SamplesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_reject_samples = /** @type {((inputs?: Samples_Reject_SamplesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Reject_SamplesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_reject_samples(inputs)
	return es_samples_reject_samples(inputs)
});